import * as React from "react";
const SvgPlus = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11 11.0024V5.00244H13V11.0024H19V13.0024H13V19.0024H11V13.0024H5V11.0024H11Z" }));
export default SvgPlus;
